import CryptoJS from 'crypto-js'
//验证是否是手机号
export function phoneValidator(phone) {
  var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
  return reg.test(phone)
}

//判断是手机还是pc
export function isMobile() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
}

//动态加载js 或 css
export const loadScript = (type = 'js', url, dom = 'body') => {
  let flag = false
  return new Promise(resolve => {
    const head = dom == 'head' ? document.getElementsByTagName('head')[0] : document.body
    for (let i = 0; i < head.children.length; i++) {
      let ele = head.children[i]
      if ((ele.src || '').indexOf(url) !== -1) {
        flag = true
        resolve()
      }
    }
    if (flag) return
    let script
    if (type === 'js') {
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
    } else if (type === 'css') {
      script = document.createElement('link')
      script.rel = 'stylesheet'
      script.type = 'text/css'
      script.href = url
    }
    head.appendChild(script)
    script.onload = function () {
      resolve()
    }
  })
}

/*
 * 获取url字符串参数
 */
export function getRequestParameters(locationhref) {
  let href = locationhref || ''
  let theRequest = new Object()
  let str = href.split('?')[1]
  if (str != undefined) {
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  return theRequest
}

// 获取合法签名
export function getLegalSign() {
  const secret = CryptoJS.enc.Utf8.parse('N7viX3kuQIeNA2jV')
  let encrypted = CryptoJS.AES.encrypt(Date.now().toString(), secret, {
    iv: secret,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}
